import { render, staticRenderFns } from "./SpreadsheetGenerator.vue?vue&type=template&id=26841018"
import script from "./SpreadsheetGenerator.vue?vue&type=script&lang=js"
export * from "./SpreadsheetGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26841018')) {
      api.createRecord('26841018', component.options)
    } else {
      api.reload('26841018', component.options)
    }
    module.hot.accept("./SpreadsheetGenerator.vue?vue&type=template&id=26841018", function () {
      api.rerender('26841018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/SpreadsheetGenerator.vue"
export default component.exports